import React, { useState, useRef, useEffect } from "react";
import "./FilterableHeader.scss";
import { Popper, Paper, ClickAwayListener } from "@mui/material";

export default function FilterableHeaderPopup({
  title,
  onClear,
  isFilterApplied = false,
  children,
}) {
  const [hover, setHover] = useState(false);
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);


  const handleFilterClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen((v) => !v);
  };

  const handleClear = () => {
    onClear?.();
    setOpen(false);
  };

  return (
    <div
      className="filterable-header"
      ref={rootRef}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className="data-tag-filter-header-title">{title}</div>

      {(hover || open || isFilterApplied) && (
        <div
          className={`header-filter-icon ${open || isFilterApplied ? "active" : ""}`}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={handleFilterClick}
        >
          <img
            src="/sysGuardIcons/filter_list_notSelected.svg"
            alt="Filter"
            className="filter-img"
          />
        </div>
      )}

      <Popper
        open={open}
        anchorEl={rootRef.current}
        placement="bottom-start"
        style={{ zIndex: 9999 }}
      >
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <Paper
            className="filter-content-container"
          >
            <div className="filter-content">{children}</div>

            <div className="filter-actions">
              <button className="btn-clear" onClick={handleClear} type="button">
                Clear
              </button>
            </div>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </div>
  );
}
